<template>
  <BaseModal :is-open="isOpen" size="sm" @close="closeInvestorProfileModal">
    <template #header>
      <NavBar>
        <span slot="left">
          <BackButton
            data-testid="back-button"
            @click="closeInvestorProfileModal"
          />
        </span>
        <span
          slot="center"
          class="wrn-color-black"
          data-testId="risk-level-title"
        >
          Perfil de investimento
        </span>
        <span slot="right">
          <CloseButton
            data-testid="close-button"
            @click="closeInvestorProfileModal"
          />
        </span>
      </NavBar>
    </template>

    <template #content>
      <ScrollShadow>
        <div class="investor-profile-content">
          <BaseText :color="NebraskaColors.textPrimary">
            Seu perfil de investidor é
            <b data-testId="investor-profile-text">{{ riskProfile.text }}</b>
            e recomendamos que você invista em produtos com nível de risco até
            <b data-testId="investor-profile-value">
              {{ riskProfile.valueText }}
            </b>
            <span>.</span>
          </BaseText>
          <BaseText class="pt-s" :color="NebraskaColors.textPrimary">
            O resultado do seu perfil de investidor é obtido através do
            suitability, você pode refazê-lo a qualquer momento.
          </BaseText>
          <BaseText class="pt-s" :color="NebraskaColors.textPrimary">
            Confira as recomendações para os níveis de risco:
          </BaseText>

          <div class="pt-s">
            <Row
              v-for="(risk, key) in dataRiskProfile"
              :key="key"
              :has-interaction="false"
              :has-line="true"
            >
              <template #top-left>
                <span class="risk-level-text">
                  {{ risk.text }}
                </span>
              </template>
              <template #icon-right>
                <div class="flex">
                  <span class="mr-xxxs star-text">até</span>
                  <RiskScore :risk-level="risk.valueRiskLevel" />
                </div>
              </template>
            </Row>
          </div>
        </div>
      </ScrollShadow>
    </template>
  </BaseModal>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';
import {
  NavBar,
  BaseText,
  Row,
  BaseModal,
  ScrollShadow
} from '@warrenbrasil/nebraska-web';
import { CloseButton } from '@/modules/common/components/buttons';
import { BackButton } from '@/modules/common/components/buttons/BackButton';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import { RiskScore } from '@/modules/common/components/RiskScore';

enum RiskProfileEnum {
  PASSIVE = 'PASSIVE',
  MODERATED = 'MODERATED',
  AGGRESSIVE = 'AGGRESSIVE'
}

@Component({
  components: {
    BaseModal,
    CloseButton,
    BackButton,
    NavBar,
    BaseText,
    ScrollShadow,
    RiskScore,
    Row
  }
})
export default class InvestorProfileModal extends Vue {
  @Prop({ type: Boolean, required: false, default: false })
  public isOpen!: boolean;

  @Prop({
    type: String,
    required: false
  })
  public computedRiskToleranceString!: RiskProfileEnum;

  private NebraskaColors = NebraskaColors;

  private dataRiskProfile = {
    PASSIVE: { text: 'Conservador', valueText: '1.66', valueRiskLevel: 1.66 },
    MODERATED: { text: 'Moderado', valueText: '3.33', valueRiskLevel: 3.33 },
    AGGRESSIVE: { text: 'Arrojado', valueText: '5.00', valueRiskLevel: 5 }
  };

  private get riskProfile() {
    return this.dataRiskProfile[this.computedRiskToleranceString];
  }

  private closeInvestorProfileModal() {
    this.$emit('close-investor-profile');
  }
}
</script>

<style lang="less" scoped>
.investor-profile-content {
  padding: calc(@size-spacing-x600 + @size-spacing-x300) @size-spacing-x800
    calc(@size-spacing-x600 + @size-spacing-x300) @size-spacing-x800;
}

.pt-s {
  padding-top: @size-spacing-x400;
}

.mr-xxxs {
  margin-right: @size-spacing-x150;
}

.flex {
  display: flex;
  align-items: center;
}

/deep/ .wrapper .icon {
  margin-top: 0 !important;
  padding-top: 0 !important;
}

.star-text {
  font-size: 22px;
  color: #2e2d33;
}

.risk-level-text {
  color: @text-secondary;
  font-size: 20px;
  line-height: 18px;
}
</style>
